import { render, staticRenderFns } from "./StationsTable.vue?vue&type=template&id=0c115352&scoped=true&"
import script from "./StationsTable.vue?vue&type=script&lang=ts&"
export * from "./StationsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c115352",
  null
  
)

export default component.exports